import React, { useEffect, useState, useRef } from "react";
import api from "../api";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "../App.css";

export default function UserProfile() {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [qrReady, setQrReady] = useState(false);
  const qrRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, async (user) => {
    if (user) {
      const email = user.email;
      try {
        const res = await api.get(`/user/profile?email=${email}`);
        setUserData(res.data);
      } catch (err) {
        console.error("Failed to fetch profile data", err);
      } finally {
        setLoading(false);
      }
    } else {
      navigate("/");
    }
  });

  return () => unsubscribe(); // cleanup listener
}, [navigate]);

  useEffect(() => {
    if (userData?.qrImage) {
      const timeout = setTimeout(() => {
        setQrReady(true);
      }, 300);

      return () => clearTimeout(timeout);
    }
  }, [userData]);

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        navigate("/");
      })
      .catch((error) => {
        console.error("Logout failed:", error);
      });
  };

  const handleDownloadPDF = async () => {
    const element = qrRef.current;

    if (!element) {
      console.error("QR code element not found.");
      return;
    }

    try {
      await new Promise((resolve) => setTimeout(resolve, 300));

      const canvas = await html2canvas(element);
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF();
      const width = pdf.internal.pageSize.getWidth();
      const height = (canvas.height * width) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, width, height);
      pdf.save(`${userData.name.replace(/\s+/g, "_")}_QR_Code.pdf`);
    } catch (error) {
      console.error("Failed to generate PDF:", error);
    }
    console.log("QR Ref Element:", qrRef.current);
  };

  if (loading) return <p className="user-profile-loading">Loading...</p>;

  if (!userData)
    return (
      <div className="user-profile-error">
        <h2 className="error-title">No registration found!</h2>
        <p>Please complete your registration first.</p>
      </div>
    );

  return (
    <div className="user-profile-container">
      <div className="user-profile-header">
        <h2 className="user-profile-title">Welcome, {userData.name}!</h2>
        <button onClick={handleLogout} className="user-profile-logout">
          Logout
        </button>
      </div>

      <div className="user-profile-info">
        <p>
          <strong>Name:</strong> {userData.name}
        </p>
        <p>
          <strong>Email:</strong> {userData.email}
        </p>
        <p>
          <strong>Phone:</strong> {userData.phone}
        </p>
        <p>
          <strong>College ID:</strong> {userData.collegeId}
        </p>
        <p>
          <strong>Stream:</strong> {userData.stream}
        </p>
        <p>
          <strong>Semester:</strong> {userData.semester}
        </p>
        <p>
          <strong>Status:</strong>{" "}
          {userData.attended ? "✅ Attended" : "❌ Not Attended"}
        </p>
      </div>

      {userData.qrImage && (
        <div className="user-profile-qr" ref={qrRef}>
          <h3 className="qr-title">Your QR Code</h3>
          <img
            src={userData.qrImage}
            alt="QR Code"
            className="qr-image"
            onLoad={() => setQrReady(true)}
          />
          <p className="qr-name">{userData.name}</p>
        </div>
      )}

      <div className="user-profile-download">
        <button
          onClick={handleDownloadPDF}
          className="download-button"
          disabled={!qrReady}
        >
          {qrReady ? "Download QR as PDF" : "Preparing...."}
        </button>
      </div>
    </div>
  );
}
